import Carousel from './carousel';

class Testimonials {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.carousel = new Carousel(self.elem, {
            cellSelector: '.testimonials__slide',
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: true,
            adaptiveHeight: true,
            arrowShape: 'M14 0V18.69L3 34L14 49.518V68',
        }).init();
        
        return self;
    }
}

export default Testimonials;
